import React from 'react';
import './SuccessPage.css';

const SuccessPage = () => {
  const handleGoHome = () => {
    // Force a redirect to the root URL.
    // This clears 'session_id' from the address bar and resets the view to Home.
    window.location.href = '/';
  };

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon-wrapper">
          <div className="success-icon">✓</div>
        </div>
        
        <h1 className="success-title">Payment Successful!</h1>
        
        <p className="success-message">
          Thank you for supporting the app. Your account has been upgraded to <strong>Premium</strong>.
        </p>
        
        <button className="btn-continue" onClick={handleGoHome}>
          Return to Songbook
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;